import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-tabs',
	templateUrl: './list-tabs.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ListTabsComponent implements OnInit {
	
	@Input() tabs: any;
	@Input() isSmall: any | undefined;
	@Input() activeTab: any | undefined;
	@Output() activeTabChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
		
		this.vm.notifyTabChange = this.notifyTabChange;
	}
	
	ngOnInit() {
		this.vm.activeTab = this.vm.activeTab || 0;
		this.vm.tabs = this.vm.tabs || [];
	}
	
	notifyTabChange(newTab) {
		this.vm.activeTab = newTab;
		this.activeTabChange.emit(newTab);
	}
	
}